/**
 * Bead Selector - Sélection de perles + breloque + calcul de prix dynamique
 */
(function() {
    'use strict';

    var BASE_PRICE = 2990; // 29.90€ en centimes

    var BEAD_SIZE_SURCHARGE = {
        '6mm': 0,
        '8mm': 175
    };

    var BRACELET_SIZE_SURCHARGE = {
        '14cm': 0, '15cm': 50, '16cm': 100, '17cm': 150, '18cm': 200,
        '19cm': 250, '20cm': 300, '21cm': 400, '22cm': 500, '23cm': 600
    };

    var BEAD_SURCHARGE = {
        'Agate Arbre': 190, 'Agate Botswana': 290, 'Agate Crazy Lace': 190,
        'Agate Mousse': 190, 'Aigue Marine': 690, 'Amazonite': 290,
        'Améthyste': 290, 'Apatite': 390, 'Aventurine': 190,
        'Azurite Malachite': 690, 'Calcédoine': 690, 'Chrysoprase': 490,
        'Citrine': 390, 'Cornaline': 190, 'Cristal de roche': 190,
        'Fluorine': 190, 'Grenat': 590, 'Hématite': 190,
        'Howlite': 190, 'Jade': 390, 'Jade Néphrite': 490,
        'Jais': 490, 'Jaspe Océan': 290, 'Jaspe Rouge': 190,
        'Labradorite': 390, 'Lapis Lazuli': 590, 'Lépidolite': 390,
        'Malachite': 590, 'Obsidienne': 190, 'Obsidienne Oeil Céleste': 290,
        'Oeil de Faucon': 290, 'Oeil de Taureau': 190, 'Oeil de Tigre': 190,
        'Onyx': 190, 'Opale Rose': 290, 'Pierre de Lave': 190,
        'Pierre de Lune': 690, 'Pierre de Soleil': 290, 'Pyrite': 190,
        'Quartz Fumé': 190, 'Quartz Rose': 190, 'Quartz Tourmaline': 390,
        'Rhodochrosite': 790, 'Rhodonite': 190, 'Shungite': 390,
        'Sodalite': 190, 'Tourmaline Noire': 390, 'Turquoise': 190,
        'Unakite': 190
    };

    var state = {
        selectedBeads: {},
        selectedTextures: {},
        selectedImages: {},
        tempSelection: {},
        breloque: null
    };


    function init() {
        var modals = document.querySelectorAll('.bead-modal');
        var buttons = document.querySelectorAll('.bead-selector-btn');

        if (modals.length === 0 || buttons.length === 0) {
            setTimeout(init, 500);
            return;
        }

        // --- Boutons "Perle X" : ouvrir la modale ---
        buttons.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                // Si le clic est sur le bouton × de suppression, ne pas ouvrir la modale
                if (e.target.classList.contains('bead-remove')) return;
                e.preventDefault();
                e.stopPropagation();
                var modalId = btn.getAttribute('data-modal-target');
                var modal = document.getElementById(modalId);
                if (modal) openModal(modal);
            });
        });

        // --- Listeners internes à chaque modale ---
        modals.forEach(function(modal) {
            var confirmBtn = modal.querySelector('.bead-modal-confirm');
            var beadIndex = modal.getAttribute('data-bead-index');

            // Fermer (croix)
            var closeBtn = modal.querySelector('.bead-modal-close');
            if (closeBtn) closeBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                closeModalAnimated(modal);
            });

            // Annuler
            var cancelBtn = modal.querySelector('.bead-modal-cancel');
            if (cancelBtn) cancelBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                closeModalAnimated(modal);
            });

            // Confirmer
            if (confirmBtn) confirmBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                if (confirmBtn.disabled) return;
                var sel = state.tempSelection[beadIndex];
                if (sel && sel.name) {
                    selectBead(beadIndex, sel.name, sel.texture, sel.image);
                }
                closeModalAnimated(modal);
            });

            // Options de perles
            modal.querySelectorAll('.bead-option').forEach(function(option) {
                option.addEventListener('click', function(e) {
                    e.stopPropagation();
                    var beadName = option.getAttribute('data-bead-name');
                    var texture = option.getAttribute('data-bead-texture') || '';
                    var image = option.getAttribute('data-bead-image') || '';

                    modal.querySelectorAll('.bead-option').forEach(function(o) {
                        o.classList.remove('selected');
                    });
                    option.classList.add('selected');

                    state.tempSelection[beadIndex] = {
                        name: beadName,
                        texture: texture,
                        image: image
                    };

                    if (confirmBtn) {
                        confirmBtn.disabled = false;
                        confirmBtn.textContent = 'Confirmer : ' + beadName;
                        // Re-trigger pulse animation
                        confirmBtn.style.animation = 'none';
                        confirmBtn.offsetHeight;
                        confirmBtn.style.animation = '';
                    }
                });
            });

            // Boutons filtre Corps/Esprit/Toutes
            modal.querySelectorAll('.bead-filter-btn').forEach(function(filterBtn) {
                filterBtn.addEventListener('click', function(e) {
                    e.stopPropagation();
                    modal.querySelectorAll('.bead-filter-btn').forEach(function(b) {
                        b.classList.remove('active');
                    });
                    filterBtn.classList.add('active');
                    filterBeads(modal);
                });
            });

            // Filtre par mal (select natif)
            var ailmentSelect = modal.querySelector('.bead-ailment-select');
            if (ailmentSelect) {
                ailmentSelect.addEventListener('change', function() {
                    filterBeads(modal);
                });
            }

            // Empty state reset button
            var resetBtn = modal.querySelector('.bead-empty-state__reset');
            if (resetBtn) {
                resetBtn.addEventListener('click', function() {
                    // Reset boutons filtre
                    modal.querySelectorAll('.bead-filter-btn').forEach(function(b) {
                        b.classList.toggle('active', b.getAttribute('data-filter') === 'all');
                    });
                    // Reset dropdown
                    var select = modal.querySelector('.bead-ailment-select');
                    if (select) select.value = '';
                    filterBeads(modal);
                });
            }

            // Backdrop
            modal.addEventListener('click', function(e) {
                if (e.target === modal) closeModalAnimated(modal);
            });

            // Image fade-in
            modal.querySelectorAll('.bead-option-image').forEach(function(img) {
                if (img.complete && img.naturalHeight > 0) {
                    img.classList.add('loaded');
                } else {
                    img.addEventListener('load', function() { img.classList.add('loaded'); });
                }
            });
        });

        // --- Breloque ---
        setupBreloque();

        setupSizeSelectors();
        setupAddToCartIntercept();
        checkUrlPreselection();
        syncToProductForm();
        updatePriceDisplay();
    }

    function closeModalAnimated(modal) {
        modal.classList.add('bead-modal--closing');
        modal.addEventListener('animationend', function handler() {
            modal.removeEventListener('animationend', handler);
            modal.classList.remove('bead-modal--closing');
            modal.close();
        });
    }

    function openModal(modal) {
        try {
            modal.showModal();
        } catch(err) {
            return;
        }

        var beadIndex = modal.getAttribute('data-bead-index');

        // Reset boutons filtre
        modal.querySelectorAll('.bead-filter-btn').forEach(function(btn) {
            btn.classList.toggle('active', btn.getAttribute('data-filter') === 'all');
        });

        // Reset dropdown
        var ailmentSelect = modal.querySelector('.bead-ailment-select');
        if (ailmentSelect) ailmentSelect.value = '';

        modal.querySelectorAll('.bead-option').forEach(function(opt) {
            opt.classList.remove('hidden');
            opt.classList.remove('selected');
        });

        // Reset empty state & counter
        var emptyState = modal.querySelector('.bead-empty-state');
        var grid = modal.querySelector('.bead-grid');
        if (emptyState) emptyState.hidden = true;
        if (grid) grid.style.display = '';

        var counterEl = modal.querySelector('.bead-results-count');
        if (counterEl) counterEl.textContent = '';

        // Reset confirm button
        var confirmBtn = modal.querySelector('.bead-modal-confirm');
        if (confirmBtn) {
            confirmBtn.textContent = 'Confirmer';
            confirmBtn.disabled = true;
        }

        state.tempSelection[beadIndex] = null;

        var currentBead = state.selectedBeads[beadIndex];
        if (currentBead) {
            modal.querySelectorAll('.bead-option').forEach(function(opt) {
                if (opt.getAttribute('data-bead-name') === currentBead) {
                    opt.classList.add('selected');
                    state.tempSelection[beadIndex] = {
                        name: currentBead,
                        texture: state.selectedTextures[beadIndex] || '',
                        image: state.selectedImages[beadIndex] || ''
                    };
                    if (confirmBtn) {
                        confirmBtn.disabled = false;
                        confirmBtn.textContent = 'Confirmer : ' + currentBead;
                    }
                }
            });
        }
    }

    function filterBeads(modal) {
        // Filtre par catégorie (boutons)
        var activeBtn = modal.querySelector('.bead-filter-btn.active');
        var categoryFilter = activeBtn ? activeBtn.getAttribute('data-filter') : 'all';

        // Filtre par mal spécifique (dropdown)
        var ailmentSelect = modal.querySelector('.bead-ailment-select');
        var selectedAilment = ailmentSelect ? ailmentSelect.value : '';

        var totalCount = 0;
        var visibleCount = 0;

        modal.querySelectorAll('.bead-option').forEach(function(option) {
            totalCount++;
            var show = true;

            // Filtre catégorie
            if (categoryFilter !== 'all') {
                var hasPhysical = option.getAttribute('data-has-physical') === 'true';
                var hasMental = option.getAttribute('data-has-mental') === 'true';
                if (categoryFilter === 'physical' && !hasPhysical) show = false;
                if (categoryFilter === 'mental' && !hasMental) show = false;
            }

            // Filtre par mal spécifique
            if (show && selectedAilment) {
                var corpsAilments = (option.getAttribute('data-ailments-corps') || '').split(',');
                var espritAilments = (option.getAttribute('data-ailments-esprit') || '').split(',');
                var allAilments = corpsAilments.concat(espritAilments);

                show = allAilments.some(function(a) {
                    return a.trim() === selectedAilment;
                });
            }

            option.classList.toggle('hidden', !show);
            if (show) visibleCount++;
        });

        // Update counter
        var counterEl = modal.querySelector('.bead-results-count');
        if (counterEl) {
            if (!selectedAilment) {
                counterEl.textContent = totalCount + ' pierres disponibles';
            } else {
                counterEl.textContent = visibleCount + ' pierre' + (visibleCount !== 1 ? 's' : '') + ' trouvée' + (visibleCount !== 1 ? 's' : '');
            }
        }

        // Toggle empty state
        var emptyState = modal.querySelector('.bead-empty-state');
        var grid = modal.querySelector('.bead-grid');
        if (emptyState && grid) {
            if (visibleCount === 0 && selectedAilment) {
                emptyState.hidden = false;
                grid.style.display = 'none';
            } else {
                emptyState.hidden = true;
                grid.style.display = '';
            }
        }
    }

    function selectBead(index, beadName, textureUrl, imageUrl) {
        var idx = String(index);
        state.selectedBeads[idx] = beadName;
        state.selectedTextures[idx] = textureUrl || imageUrl || '';
        state.selectedImages[idx] = imageUrl || '';

        var selectorItem = document.querySelector('.bead-selector-item[data-bead-index="' + idx + '"]');
        if (!selectorItem) return;

        var btn = selectorItem.querySelector('.bead-selector-btn');
        var input = selectorItem.querySelector('input[type="hidden"]');
        var preview = selectorItem.querySelector('.bead-selector-preview');
        var valueLabel = selectorItem.querySelector('.bead-selector-value');

        if (input) {
            input.value = beadName;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (preview) {
            var imgSrc = imageUrl || textureUrl;
            if (imgSrc) {
                preview.innerHTML = '<img src="' + imgSrc + '" alt="' + beadName + '" style="width:100%;height:100%;object-fit:cover;border-radius:50%;">';
            } else {
                preview.innerHTML = '<span class="bead-selector-placeholder">' + beadName.charAt(0).toUpperCase() + '</span>';
            }
        }

        if (valueLabel) {
            valueLabel.textContent = beadName;
            valueLabel.style.color = 'var(--bead-accent, #4a7c59)';
            valueLabel.style.fontWeight = '600';
        }

        if (btn) {
            btn.classList.add('selected');
            // Ajouter le bouton × si pas déjà présent
            if (!btn.querySelector('.bead-remove')) {
                var removeSpan = document.createElement('span');
                removeSpan.className = 'bead-remove';
                removeSpan.textContent = '×';
                removeSpan.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    removeBead(idx);
                });
                btn.appendChild(removeSpan);
            }
        }

        dispatchBeadChange();
        syncToProductForm();
        updatePriceDisplay();
    }

    function removeBead(index) {
        var idx = String(index);
        delete state.selectedBeads[idx];
        delete state.selectedTextures[idx];
        delete state.selectedImages[idx];

        var selectorItem = document.querySelector('.bead-selector-item[data-bead-index="' + idx + '"]');
        if (!selectorItem) return;

        var btn = selectorItem.querySelector('.bead-selector-btn');
        var input = selectorItem.querySelector('input[type="hidden"]');
        var preview = selectorItem.querySelector('.bead-selector-preview');
        var valueLabel = selectorItem.querySelector('.bead-selector-value');

        if (input) {
            input.value = '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (preview) {
            preview.innerHTML = '<span class="bead-selector-placeholder">+</span>';
        }

        if (valueLabel) {
            valueLabel.textContent = 'Choisir une pierre';
            valueLabel.style.color = '';
            valueLabel.style.fontWeight = '';
        }

        if (btn) {
            btn.classList.remove('selected');
            var removeBtn = btn.querySelector('.bead-remove');
            if (removeBtn) removeBtn.remove();
        }

        dispatchBeadChange();
        syncToProductForm();
        updatePriceDisplay();
    }

    function setupBreloque() {
        var breloqueBtn = document.querySelector('.breloque-selector-btn');
        var breloqueModal = document.getElementById('breloque-modal');
        if (!breloqueModal) return;

        // Ouvrir la modale
        if (breloqueBtn) {
            breloqueBtn.addEventListener('click', function(e) {
                e.preventDefault();
                // Reset sélection temp
                breloqueModal.querySelectorAll('.breloque-option').forEach(function(o) {
                    o.classList.remove('selected');
                });
                var confirmBtn = breloqueModal.querySelector('.breloque-modal-confirm');
                if (confirmBtn) confirmBtn.disabled = true;
                state.tempBreloque = null;
                breloqueModal.showModal();
            });
        }

        // Fermer (croix)
        var closeBtn = breloqueModal.querySelector('.bead-modal-close');
        if (closeBtn) closeBtn.addEventListener('click', function() {
            closeModalAnimated(breloqueModal);
        });

        // Annuler
        var cancelBtn = breloqueModal.querySelector('.breloque-modal-cancel');
        if (cancelBtn) cancelBtn.addEventListener('click', function() {
            closeModalAnimated(breloqueModal);
        });

        // Backdrop
        breloqueModal.addEventListener('click', function(e) {
            if (e.target === breloqueModal) closeModalAnimated(breloqueModal);
        });

        // Sélection d'une breloque
        var confirmBtn = breloqueModal.querySelector('.breloque-modal-confirm');
        breloqueModal.querySelectorAll('.breloque-option').forEach(function(option) {
            option.addEventListener('click', function(e) {
                e.stopPropagation();
                breloqueModal.querySelectorAll('.breloque-option').forEach(function(o) {
                    o.classList.remove('selected');
                });
                option.classList.add('selected');
                state.tempBreloque = {
                    name: option.getAttribute('data-breloque-name'),
                    image: option.getAttribute('data-breloque-image')
                };
                if (confirmBtn) confirmBtn.disabled = false;
            });
        });

        // Confirmer
        if (confirmBtn) confirmBtn.addEventListener('click', function() {
            if (!state.tempBreloque) return;
            state.breloque = state.tempBreloque.name;
            state.breloqueImage = state.tempBreloque.image;

            // Mettre à jour le bouton
            if (breloqueBtn) {
                breloqueBtn.textContent = '';
                breloqueBtn.classList.add('selected');

                var img = document.createElement('img');
                img.src = state.breloqueImage;
                img.alt = state.breloque;
                img.style.cssText = 'width:28px;height:28px;border-radius:50%;object-fit:cover;';
                breloqueBtn.appendChild(img);

                var span = document.createElement('span');
                span.textContent = state.breloque;
                breloqueBtn.appendChild(span);

                // Bouton × pour retirer
                var removeSpan = document.createElement('span');
                removeSpan.className = 'bead-remove';
                removeSpan.textContent = '×';
                removeSpan.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    removeBreloque();
                });
                breloqueBtn.appendChild(removeSpan);
            }

            // Dispatch event pour le bridge (bracelet 3D)
            document.dispatchEvent(new CustomEvent('breloqueChange', {
                detail: { name: state.breloque, image: state.breloqueImage }
            }));

            syncToProductForm();
            closeModalAnimated(breloqueModal);
        });
    }

    function removeBreloque() {
        state.breloque = null;
        state.breloqueImage = null;

        var breloqueBtn = document.querySelector('.breloque-selector-btn');
        if (breloqueBtn) {
            breloqueBtn.textContent = '+ Ajouter une breloque';
            breloqueBtn.classList.remove('selected');
        }

        // Retirer du bracelet 3D
        document.dispatchEvent(new CustomEvent('breloqueChange', {
            detail: { name: null, image: null }
        }));

        // Retirer du formulaire
        var form = document.querySelector('form[action*="/cart/add"]');
        if (form) {
            var input = form.querySelector('input[name="properties[Breloque]"]');
            if (input) input.remove();
        }
    }

    function getBeadSizeValue() {
        var radio = document.querySelector('input[name="properties[beads-size]"]:checked');
        return radio ? radio.value : '6mm';
    }

    function getBraceletSizeValue() {
        var radio = document.querySelector('input[name="properties[size]"]:checked');
        return radio ? radio.value : '17cm';
    }

    function syncToProductForm() {
        var form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return;

        // Sync perles
        for (var key = 1; key <= 4; key++) {
            var k = String(key);
            var bead = state.selectedBeads[k] || '';

            var inputName = 'properties[Perle ' + k + ']';
            var input = form.querySelector('input[name="' + inputName + '"]');
            if (!input) {
                input = document.createElement('input');
                input.type = 'hidden';
                input.name = inputName;
                form.appendChild(input);
            }
            input.value = bead;
        }

        // Sync breloque
        if (state.breloque) {
            var breloqueInput = form.querySelector('input[name="properties[Breloque]"]');
            if (!breloqueInput) {
                breloqueInput = document.createElement('input');
                breloqueInput.type = 'hidden';
                breloqueInput.name = 'properties[Breloque]';
                form.appendChild(breloqueInput);
            }
            breloqueInput.value = state.breloque;
        }

        // Mettre à jour le variant ID dans le formulaire
        updateVariantId();
    }

    function updateVariantId() {
        var braceletVariants = window.braceletVariants || {};
        var beadSize = getBeadSizeValue();
        var braceletSize = getBraceletSizeValue();

        var variantKey = beadSize + '/' + braceletSize;
        var variantId = braceletVariants[variantKey];
        if (!variantId) return;

        var form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return;

        var idInput = form.querySelector('input[name="id"]');
        if (!idInput) {
            idInput = document.createElement('input');
            idInput.type = 'hidden';
            idInput.name = 'id';
            form.appendChild(idInput);
        }
        idInput.value = variantId;
    }

    /**
     * Intercepte l'ajout au panier pour ajouter le bracelet + les suppléments pierres
     */
    function setupAddToCartIntercept() {
        var form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return;

        // Trouver le product-form-component parent
        var productForm = form.closest('product-form-component');

        // Désactiver complètement le product-form-component pour ce produit
        // On gère l'ajout au panier nous-mêmes via addBraceletToCart()
        var productFormComponent = form.closest('product-form-component');
        if (productFormComponent) {
            // Retirer le formulaire du product-form-component pour qu'il ne le gère plus
            // On clone le form dans un wrapper neutre
            var wrapper = document.createElement('div');
            wrapper.className = 'bead-form-wrapper';
            form.parentNode.insertBefore(wrapper, form);
            wrapper.appendChild(form);
        }

        // Notre propre bouton submit
        var submitBtn = form.querySelector('[type="submit"], [name="add"], .product-form__submit');

        if (submitBtn) {
            // Remplacer le type submit par button pour empêcher la soumission native
            submitBtn.type = 'button';

            submitBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                // Vérifier qu'au moins 1 perle est sélectionnée
                var beadCount = 0;
                for (var k = 1; k <= 4; k++) {
                    if (state.selectedBeads[String(k)]) beadCount++;
                }

                if (beadCount === 0) {
                    alert('Veuillez sélectionner au moins une perle.');
                    return;
                }

                addBraceletToCart();
            });
        }
    }

    function addBraceletToCart() {
        var supplementVariants = window.supplementVariants || {};
        var braceletVariants = window.braceletVariants || {};

        var beadSize = getBeadSizeValue();
        var braceletSize = getBraceletSizeValue();

        // Trouver le variant ID du bracelet selon les tailles
        var variantKey = beadSize + '/' + braceletSize;
        var braceletVariantId = braceletVariants[variantKey];

        if (!braceletVariantId) {
            alert('Erreur : combinaison de tailles non trouvée. Veuillez réessayer.');
            return;
        }

        // Construire la liste des items à ajouter
        var groupId = Date.now().toString();
        var items = [];

        // 1. Le bracelet principal avec les propriétés
        var braceletProps = {
            '_bracelet_group': groupId
        };
        for (var k = 1; k <= 4; k++) {
            var beadName = state.selectedBeads[String(k)];
            if (beadName) braceletProps['Perle ' + k] = beadName;
        }
        braceletProps['Taille des perles'] = beadSize;
        braceletProps['Taille du bracelet'] = braceletSize;
        if (state.breloque) braceletProps['Breloque'] = state.breloque;

        items.push({
            id: braceletVariantId,
            quantity: 1,
            properties: braceletProps
        });

        // 2. Les suppléments pierres
        for (var j = 1; j <= 4; j++) {
            var stoneName = state.selectedBeads[String(j)];
            if (stoneName && supplementVariants[stoneName]) {
                items.push({
                    id: supplementVariants[stoneName],
                    quantity: 1,
                    properties: {
                        '_bracelet_group': groupId,
                        '_slot': String(j),
                        '_stone': stoneName
                    }
                });
            }
        }

        // Désactiver le bouton pendant l'ajout
        var addBtn = document.querySelector('[name="add"], .product-form__submit, button[type="submit"]');
        if (addBtn) addBtn.disabled = true;

        // Trouver le section ID du cart drawer pour le demander dans la réponse
        var cartItemsComp = document.querySelector('cart-items-component');
        var cartSectionId = cartItemsComp ? cartItemsComp.dataset.sectionId : '';

        // Construire le body avec sections pour obtenir le HTML mis à jour dans la réponse
        var requestBody = { items: items };
        if (cartSectionId) {
            requestBody.sections = cartSectionId;
            requestBody.sections_url = window.location.pathname;
        }

        // Appeler l'API cart/add.js
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        })
        .then(function(response) {
            if (!response.ok) throw new Error('Erreur ajout au panier');
            return response.json();
        })
        .then(function() {
            var comp = document.querySelector('cart-items-component');
            var sectionId = comp ? comp.dataset.sectionId : '';
            if (!comp || !sectionId) { window.location.href = '/cart'; return; }

            // Ouvrir le drawer d'abord
            var cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
                cartDrawer.showDialog();
            }

            // Fetch la section fraîche et dispatcher avec le HTML
            fetch(window.location.pathname + '?section_id=' + sectionId + '&_=' + Date.now())
                .then(function(r) { return r.text(); })
                .then(function(html) {
                    console.log('[BEAD] Section fetched, dispatching cart:update with HTML (' + html.length + ' chars)');
                    var sections = {};
                    sections[sectionId] = html;
                    document.dispatchEvent(new CustomEvent('cart:update', {
                        bubbles: true,
                        detail: {
                            data: {
                                sections: sections,
                                sourceId: 'bead-selector'
                            }
                        }
                    }));
                });
        })
        .catch(function(err) {
            console.error('Erreur ajout au panier:', err);
            alert('Une erreur est survenue lors de l\'ajout au panier. Veuillez réessayer.');
        })
        .finally(function() {
            if (addBtn) addBtn.disabled = false;
        });
    }

    function setupSizeSelectors() {
        var beadSizePills = document.getElementById('beads-size-pills');
        var braceletSizePills = document.getElementById('bracelet-size-pills');

        if (beadSizePills) beadSizePills.addEventListener('change', function() {
            syncToProductForm();
            dispatchBeadChange();
            updatePriceDisplay();
        });
        if (braceletSizePills) braceletSizePills.addEventListener('change', function() {
            syncToProductForm();
            dispatchBeadChange();
            updatePriceDisplay();
        });
    }

    function checkUrlPreselection() {
        var urlParams = new URLSearchParams(window.location.search);
        var beadParams = {
            '1': urlParams.get('b1'),
            '2': urlParams.get('b2'),
            '3': urlParams.get('b3'),
            '4': urlParams.get('b4')
        };

        var hasAny = beadParams['1'] || beadParams['2'] || beadParams['3'] || beadParams['4'];

        // Fallback : lire depuis sessionStorage (quizz cross-theme)
        if (!hasAny) {
            try {
                var stored = JSON.parse(sessionStorage.getItem('quizzBeads'));
                if (stored && stored.length) {
                    for (var j = 0; j < Math.min(stored.length, 4); j++) {
                        if (stored[j]) beadParams[String(j + 1)] = stored[j];
                    }
                    hasAny = beadParams['1'] || beadParams['2'] || beadParams['3'] || beadParams['4'];
                    // Nettoyer après lecture pour ne pas re-appliquer à chaque visite
                    sessionStorage.removeItem('quizzBeads');
                }
            } catch(e) {}
        }

        if (!hasAny) return;

        // Toutes les options de perles (la première modale suffit, elles sont identiques)
        var allOptions = document.querySelectorAll('#bead-modal-1 .bead-option');

        Object.keys(beadParams).forEach(function(index) {
            var beadName = beadParams[index];
            if (!beadName) return;

            beadName = decodeURIComponent(beadName).trim();
            var beadNameLower = beadName.toLowerCase();

            // Chercher par nom (insensible à la casse, gère title vs name)
            for (var i = 0; i < allOptions.length; i++) {
                var optName = (allOptions[i].getAttribute('data-bead-name') || '').trim();
                if (optName.toLowerCase() === beadNameLower) {
                    var texture = allOptions[i].getAttribute('data-bead-texture') || '';
                    var image = allOptions[i].getAttribute('data-bead-image') || '';
                    selectBead(index, optName, texture, image);
                    break;
                }
            }
        });
    }

    function calculatePrice() {
        var beadSizeVal = getBeadSizeValue();
        var braceletSizeVal = getBraceletSizeValue();

        var total = BASE_PRICE;
        total += BEAD_SIZE_SURCHARGE[beadSizeVal] || 0;
        total += BRACELET_SIZE_SURCHARGE[braceletSizeVal] || 0;

        for (var k = 1; k <= 4; k++) {
            var beadName = state.selectedBeads[String(k)];
            if (beadName && BEAD_SURCHARGE[beadName] != null) {
                total += BEAD_SURCHARGE[beadName];
            }
        }

        return total;
    }

    function updatePriceDisplay() {
        var totalCents = calculatePrice();
        var totalEuros = (totalCents / 100).toFixed(2).replace('.', ',');
        var formattedPrice = totalEuros + ' €';

        // Cibler le prix dans le thème Horizon : product-price [ref="priceContainer"] .price
        var priceEls = document.querySelectorAll('product-price [ref="priceContainer"] .price');
        if (priceEls.length > 0) {
            priceEls.forEach(function(el) { el.textContent = formattedPrice; });
            return;
        }

        // Fallback
        var anyPrice = document.querySelector('product-price .price, product-price .money');
        if (anyPrice) anyPrice.textContent = formattedPrice;
    }

    function dispatchBeadChange() {
        var detail = {
            beads: Object.assign({}, state.selectedBeads),
            textures: Object.assign({}, state.selectedTextures),
            beadSize: getBeadSizeValue(),
            braceletSize: getBraceletSizeValue()
        };

        document.dispatchEvent(new CustomEvent('beadSelectionChange', { detail: detail }));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.beadSelector = state;
})();
